module.exports = __webpack_public_path__ + "img/music-left-2.6192d245.png";